import { bool } from "prop-types";
import { observer } from "mobx-react";
import {
  usePresetFieldNames,
  useEstimateEditorStore,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  useEstimateEditorSettings,
  ValueCell,
  VisibilityButton,
} from "@tools";

export const HoursCell = observer((cellProps) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const { hideSummaryHours } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryHours);
  
  return (
    <ValueCell
      size="large"
      isHeader
      className={className}
      style={{ cursor: allowEdition && "grab" }}
      { ...cellProps }
    >
      <span className="preset-tableSummaryHeader pt-time">
        {getFieldName("pt-time")}
      </span>
      {
        visibilityMode &&
        <VisibilityButton
          size="tiny"
          inColumn right={32}
          hidden={hideSummaryHours}
          onChange={structure.visibility.setHideSummaryHours}
        />
      }
    </ValueCell>
  )
})

HoursCell.propTypes = {
  extendPadding: bool,
}